module.exports = __webpack_public_path__ + "img/372f56d.jpg";